<template>
  <section class="user-overview">
    <h2 class="title">Score Overview</h2>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
      right
      slider-color="yellow lighten-1"
    >
      <v-tab ripple href="#overview">Overview</v-tab>
      <v-tab ripple href="#learning-area">Learning Area</v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tab">
      <v-tab-item value="overview">
        <v-card flat>
          <bar-chart ref="barChart" :chart-data="overviewData" />
        </v-card>
      </v-tab-item>
      <v-tab-item value="learning-area">
        <v-card flat>
          <learning-area ref="learningArea" :learning-areas="learningAreas" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-divider class="my-4" />
  </section>
</template>
<script>
import _ from 'lodash'
import Lesson from '@/modules/lesson/models/Lesson'
import BarChart from '@/components/charts/BarChart'
import LearningArea from './learning_area/LearningArea'

export default {
  name: 'UserOverview',
  components: {
    BarChart,
    LearningArea
  },
  props: {
    userLessons: {
      type: Array,
      required: true
    },
    learningAreas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tab: null,
      loaded: false
    }
  },
  mounted() {},
  watch: {
    tab() {
      if (this.$refs.barChart) this.$refs.barChart.updateChart()
      if (this.$refs.learningArea) this.$refs.learningArea.updateChart()
    }
  },
  computed: {
    overviewData() {
      let userLessons = this.userLessons
      let labels = []
      let prequiz = {
        label: 'Pre Quiz',
        stack: 1,
        backgroundColor: '#00ABD7',
        data: []
      }

      let postquiz = {
        label: 'Post Quiz',
        stack: 2,
        backgroundColor: '#8AFBFF',
        data: []
      }
      if (!userLessons.length) {
        labels = ['No Data']
        prequiz.data = [0]
        postquiz.data = [0]
        return { labels, datasets: [prequiz, postquiz] }
      }

      _.forEach(userLessons, value => {
        if (value.completed_at !== null) {
          let lesson = Lesson.find(value.lesson_id)
          labels = [
            ...labels,
            [
              lesson.name,
              this.$moment(value.completed_at).format('DD MMM YYYY')
            ]
          ]
          prequiz.data = [...prequiz.data, value.pre_quiz]
          postquiz.data = [...postquiz.data, value.post_quiz]
        }
      })

      let datasets = [prequiz, postquiz]
      let chartData = { labels, datasets }
      return chartData
    }
  },
  methods: {
    initialiseGraphs() {
      this.$nextTick(() => {
        if (this.$refs.barChart) {
          this.$refs.barChart.updateChart()
        }
        if (this.$refs.learningArea) this.$refs.learningArea.updateChart()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-overview {
  position: relative;
  overflow: hidden;

  .title {
    left: 10px;
    color: white;
    position: absolute;
    top: 10px;
    font-size: 23px !important;
    z-index: 2;
    right: 10px;
    width: 300px;
  }
}
</style>
